
<script>

  import { Radar } from 'vue-chartjs'

  export default {
    extends: Radar,
    props: {
      highestYValue: {
        type: Number,
        default: undefined,
      },
      movement: {
        type: String,
        default: 'in',
      },
      branch: {
        type: Object,
        default: undefined,
      },
      data: {
        type: Array,
        default: () => {
          return [] 
        },
      },
      labels: {
        type: Array,
        default: () => {
          return []
        },
      },

    },
    data () {
      return {
        options: {
          legend: {
            onClick: null,
          }, 
          responsive: true,
          maintainAspectRatio: false,
          scale: {
            ticks: {
              min: 0,
              max: 5,
            },
          },
        },

      }
    },
    computed: {
      dynamicOptions () {
        let options = this.options
        options.scale.ticks.max = this.highestYValue
        return options
      },
    },
    watch: {
      data: {
        handler (value) {
          if (value) {
            this.renderChart({
              labels: this.labels,
              datasets: this.data,    
            }, this.dynamicOptions)
          }
        },
      },
    },
    mounted () {   
    
    },
    methods: {
    
    },
  }
</script>
